import type { PaletteCommand } from "@/components/command-palette/types";
import { create } from "zustand";

type PaletteCommandsState = {
  registrations: Record<string, PaletteCommand[]>;
  register: (registrationId: string, commands: PaletteCommand[]) => void;
  unregister: (registrationId: string) => void;
};

export const paletteCommandsStore = create<PaletteCommandsState>()((set) => ({
  registrations: {},
  register: (registrationId, commands) =>
    set((state) => ({ registrations: { ...state.registrations, [registrationId]: commands } })),
  unregister: (registrationId) =>
    set((state) => ({
      registrations: Object.fromEntries(Object.entries(state.registrations).filter(([id]) => id !== registrationId)),
    })),
}));
